'use client';

import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useContext } from 'react';
import { ReactComponent as CloseIcon } from '@icons/close-lg.svg';
import { authContext } from '@/context/auth';
import { getClassNames } from '@/utils/helpers';

export default function VideoGuideModal() {
  const { isVideoGuideOpen, setIsVideoGuideOpen } = useContext(authContext) as {
    isVideoGuideOpen: boolean;
    setIsVideoGuideOpen: (isOpen: boolean) => void;
  };
  const onClose = () => {
    setIsVideoGuideOpen(false);
  };
  return (
    <Transition appear show={isVideoGuideOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={getClassNames(
                  `transform rounded-lg bg-white text-left align-middle w-full max-w-4xl
              shadow-[0px_4px_10px_rgba(0,0,0,0.05)] transition-all p-4`
                )}
              >
                <Dialog.Title
                  as="div"
                  className={getClassNames(
                    'flex justify-between items-center text-base1 leading-xl',
                    'bg-white rounded-t-2xl mb-2'
                  )}
                >
                  <h2 className="text-lg text-black font-normal">Video Guide</h2>
                  <CloseIcon
                    onClick={() => onClose()}
                    className="cursor-pointer w-4 h-4 hover:stroke-black transition-stroke duration-200"
                  />
                </Dialog.Title>

                <div className="bg-white2 border border-grey-stroke-primary rounded-lg h-[408px] flex items-center justify-center">
                  <iframe
                    width="860"
                    height="406"
                    src="https://www.youtube.com/embed/1NgPEdJWfi8?si=vDy7KKjc0qlo85T0"
                    title="Trudenty Console Guide"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                  {/* <iframe
                    src="https://www.youtube.com/embed/1NgPEdJWfi8?si=vDy7KKjc0qlo85T0"
                    style={{
                      position: 'absolute',
                      inset: '0',
                      width: '100%',
                      height: '100%',
                      border: '0',
                    }}
                    allow="autoplay; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                  ></iframe> */}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
